import { useCallback, useEffect, useRef, useState } from "react"

const SPACE_OFFSET = 20

export const useScrollSpy = (
  sectionIds: string[],
  containerRef: React.RefObject<HTMLElement | null>,
) => {
  const [activeId, setActiveId] = useState<string>(sectionIds[0] ?? "")
  const observerRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container || sectionIds.length === 0) return

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)

        if (visible.length > 0) {
          setActiveId(visible[0].target.id)
        }
      },
      {
        root: container,
        rootMargin: "-10% 0px -80% 0px",
        threshold: 0,
      },
    )

    sectionIds.forEach((id) => {
      const el = document.getElementById(id)
      if (el) observerRef.current?.observe(el)
    })

    return () => observerRef.current?.disconnect()
  }, [sectionIds, containerRef])

  const scrollTo = useCallback(
    (id: string) => {
      const el = document.getElementById(id)
      const container = containerRef.current
      if (el && container) {
        const offsetTop = el.offsetTop - container.offsetTop - SPACE_OFFSET
        container.scrollTo({ top: offsetTop, behavior: "smooth" })
      }
    },
    [containerRef],
  )

  return { activeId, scrollTo }
}
